module.exports = __webpack_public_path__ + "media/packs/images/add-shipment-icon-b02435fadaf57b95b3c1218cb0bbc466.svg";